import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import styles from './SuperscriptSlatePlugin.scss'
import { TYPE, TRIGGER_KEY, hasSuperscript, onClickButton } from './SuperscriptSlatePluginContainer'

class SuperscriptButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, noTooltip, onChange, style } = this.props
    const isActive = hasSuperscript(editorState)

    const customStyle = {fontFamily: 'serif'}

    return (
      <Button
        id={'SuperscriptButton' + (noTooltip ? '' : this.uid)}
        style={{...style, ...customStyle}}
        onClick={e => onChange(onClickButton(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.SuperscriptButton}
      > T<sup>I</sup>
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'SuperscriptButton' + this.uid} toggle={this.toggle}>
            {TYPE} (CTL+{TRIGGER_KEY.toUpperCase()})
          </Tooltip>
        }
      </Button>
    )
  }
}

SuperscriptButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default SuperscriptButton



// WEBPACK FOOTER //
// ./src/components/SuperscriptSlatePlugin/SuperscriptButton.js